import React from 'react';
import { Modal } from '../../../../components/containers/Modal';
import { ButtonColorsEnum } from '../../../../constants/button-colors';

export type ShuffleModalViewProps = {
  onClose: (confirm: boolean) => void;
};

export const ShuffleModalView = (props: ShuffleModalViewProps): JSX.Element => {
  return (
    <Modal
      title={'Shuffle Posts'}
      onClose={() => props.onClose(false)}
      showCloseIcon={true}
      primaryButtonColor={ButtonColorsEnum.secondary}
      primaryButtonTitle={'Shuffle Posts'}
      primaryButtonAction={() => props.onClose(true)}>
      <>
        <div>
          All visible Posts (based on the current filters applied) will be shuffled within their separate
          Profile-Category Queues.
        </div>
        <div>Posts with fixed dates - or a custom recurring schedule - will not be affected.</div>
      </>
    </Modal>
  );
};
